export const chunk = (array, size) =>
  array.reduce((chunked, element, index) => {
    const chunkIndex = Math.floor(index / size);

    if (!chunked[chunkIndex]) {
      chunked[chunkIndex] = [];
    }

    chunked[chunkIndex].push(element);

    return chunked;
  }, []);
